import styled from "styled-components"
import { Container, Row, Col } from "react-bootstrap";
import Wrapper from "../Home/Wrappe";


const Skilldiv = styled.div`
margin-top: 50px;
   
     
      width: 100%;
      margin:0 auto;
    justify-content: center;
    align-items: center;
    .skillsdiv{
        justify-content: center;
        display: grid;
    

        grid-template-columns: repeat(6,1fr);
    }

    @media (max-width:450px){
        .skillsdiv{
            width: 100%;
        justify-content: center;
        display: grid;
       
        border: 2px solid white;
        grid-template-columns: repeat(2,1fr);
    }
}
    @media  screen and (min-width: 451px) and (max-width: 800px){
        .skillsdiv{
            width: 100%;
           
        justify-content: center;
        display: grid;
        border: 2px solid white;
        grid-template-columns: repeat(3,1fr);
    }
    }
      .langudiv{
          font-size: 40px;
      }
      .icanworkdiv{
        
          width: 30%;
          margin-left: 20px;
          font-size: 4.5rem;
       }
      
      .icanworkdiv > img{
          margin-top: 150px;
          width: 250px;
      }
.skillcolum > div > img{
    width: 80px;
    height: 80px;

    border-radius: 50px;

        }
        .skillcolum{
            width: fit-content;
            width: 200px;
            height: 200px;
            font-size: 25px;
      
        }
       .skillcolum > :first-child{
        /* width: 150px;
        height: 150px; */
        width: fit-content;
        height: fit-content;
        margin-left: 40px;
        padding: 20px;
        justify-content:center;
        text-align: center;
        align-items: center;
        border-radius:50% ;
        background: #343E47;
       }
       .skillcolum > :last-child{
        /* width: 150px;
        height: 150px; */
       
       
       
       }
       .skillcolum > :first-child:hover{
        /* width: 150px;
        height: 150px; */
        box-shadow: 0 4px 5px 3px #343e47 !important;
       }
        @media (max-width:600px) {
      display: flex;
      width: 100%;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    /* & > img{
      width:90%;
    } */

    .icanworkdiv{
 
          width: 90%;
   
          font-size: 4.5rem;
          border: 2px solid red;
       }
      
      .icanworkdiv > img{
          /* margin-top: 150px; */
          margin-bottom: 0px;
          width: 250px;
      }
      .icanworkdiv > span{
          /* margin-top: 150px; */
          margin-top: 0px;
          font-size: 50px;
          width: 250px;
      }
      
  }
      
    `;

function Skills(){
    // AOS.init({
    //     delay: 150,
    //     duration: 1000
    //   });
      
    
   
    return ( <Wrapper >
        <div id="skill">

        <Row className="skill-tools-wrapper"  style={{
             justifyContent: "center",
             marginTop:"10px",
             marginRight: "0px",
             marginLeft: "0px"


        }}>
        <Col className="skill-wrapper">
          <h1 className="project-heading">
            Professional <strong className="purple">Skillset </strong>
          </h1>
        <Skilldiv id="skills" >
     
    
     

          <div className="skillsdiv" >
          
                  <div className="skillcolum">
                      <div >
                      <img src="https://cdn3.iconfinder.com/data/icons/popular-services-brands/512/html5-512.png" alt="" srcset="" />
                      </div>
                      <div>
                            HTML
                      </div>
                  </div>
                  <div className="skillcolum">
                      <div >
                      <img src="https://cdn1.iconfinder.com/data/icons/social-media-logos-7/64/css-3-512.png" alt="" srcset="" />
                      </div>
                      <div>
                            CSS
                      </div>
                  </div>
                  <div className="skillcolum">
                      <div>
                      <img src="https://cdn.iconscout.com/icon/free/png-256/javascript-2752148-2284965.png" alt="" srcset="" />
                      </div>
                      <div>
                            Java Script
                      </div>
                  </div>
                  
                  <div className="skillcolum">
                      <div>
                  <img src="https://cdn.svgporn.com/logos/react.svg" alt="" srcset="" />
    
                      </div>
                      <div>
                            React
                      </div>
                  </div>
                  <div className="skillcolum">
                      <div>
                  <img src="https://portfolio1-nishthaarya.vercel.app/static/media/redux.168e37f0.png" alt="" srcset="" />

                      </div>
                      <div>
                            Redux
                      </div>
                  </div>
                  <div className="skillcolum">
                      <div>
                      <img src="https://www.gauravtambe.com/static/media/styledComponentsPng.67fab711.png" alt="" srcset="" />

                      </div>
                      <div>
                      Styled
                      </div>
                  </div>
                  <div className="skillcolum">
                      <div>
                      <img src="https://www.gauravtambe.com/static/media/materialuipng.5b2d8a0a.png" alt="" srcset="" />
                      </div>
                      <div>
                        Material UI
                      </div>
                  </div>
           
                  <div className="skillcolum">
                      <div>
                      <img src="https://e7.pngegg.com/pngimages/925/447/png-clipart-express-js-node-js-javascript-mongodb-node-js-text-trademark.png" alt="" srcset="" />
             
    
                      </div>
                      <div>
                            Express Js
                      </div>
                  </div>
                  <div className="skillcolum">
                      <div>
                      <img src="https://banner2.cleanpng.com/20180403/hyq/kisspng-mongodb-node-js-npm-open-source-model-angularjs-leaf-5ac44d9ed28fc7.7809651415228143668625.jpg" alt="" srcset="" />


                      </div>
                      <div>
                           MongoDB
                      </div>
                  </div>
                  <div className="skillcolum">
                      <div>
                      <img src="https://e7.pngegg.com/pngimages/788/406/png-clipart-node-js-scalable-graphics-javascript-react-scratch-logo-angle-text.png" alt="" srcset="" />

                      </div>
                      <div>
                      Node Js
                      </div>
                  </div>
                
                  <div className="skillcolum">
                      <div>
                      <img src="https://www.learnsimpli.com/wp-content/uploads/2021/05/Data-structure-and-algorithms.png" alt="" srcset="" />

                      </div>
                      <div>
                  DSA
                      </div>
                  </div>
                  <div className="skillcolum">
                      <div>
                      <img src="https://logodix.com/logo/1974428.png" alt="" srcset="" />

                      </div>
                      <div>
                  npm
                      </div>
                  </div>

          </div>
       
        </Skilldiv>
        </Col>
        </Row>
        </div>
    </Wrapper>

    )
}

export default Skills